export const pricingPlanData = [
    { title: 'All Access', price: '$9,99' },
    { title: 'Group Access', price: '$34,99' },
    { title: 'Student Access', price: '$6,99' }
];